<template>
	<div id="app">
		<Navigation />
		<MusicIcon @player="
        (i) => {
          player = i;
        }
      " />
		<Return />
		<transition mode="out-in">
			<keep-alive>
				<router-view :player="player" />
			</keep-alive>
		</transition>
	</div>
</template>
<script>
	import Navigation from './components/Navigation.vue'
	import MusicIcon from './components/MusicIcon.vue'
	import Return from './components/return.vue'
	export default ({
		components: {
			Navigation,
			MusicIcon,
			Return
		},
		data() {
			return {
				name: "HomePage",
				player: NaN
			}
		},
	})
</script>

<style scoped>
	.v-leave-to,
	.v-enter {
		opacity: 0;
	}

	.v-enter-active,
	.v-leave-active {
		transition: all 0.2s ease-in-out;
	}
</style>
